import type { ModuleManifest } from "./types";

export const contentManifest: ModuleManifest = {
  name: "content",
  label: "Contenuto",
  labelPlural: "Contenuti",
  coreBOSModule: "cbContent",
  wsidPrefix: "85x",
  type: "standard",
  routes: {
    list: "/content",
    show: "/content/show/:id",
    create: "/content/create",
    edit: "/content/edit/:id",
  },
  navigation: {
    icon: "ReadOutlined",
    order: 4,
    group: "Compliance",
    hidden: false,
  },
  routing: {
    keywords: ["content", "contenuto", "contenuti", "article"],
    searchFields: ["title"],
    defaultSort: { field: "createdtime", order: "desc" },
  },
  context: { supported: false, entityKey: "content" },
  fields: [
    { name: "title", label: "Titolo", type: "string", required: true },
    { name: "content", label: "Contenuto", type: "text" },
    { name: "description", label: "Descrizione", type: "text" },
    { name: "position", label: "Posizione", type: "string" },
    { name: "page", label: "Pagina", type: "string" },
    { name: "contenttocontact", label: "Contatto", type: "reference" },
    { name: "cbcontent_no", label: "Numero", type: "string" },
    { name: "assigned_user_id", label: "Assegnato a", type: "reference" },
  ],
  relationships: [
    {
      module: "Contacts",
      field: "contenttocontact",
      relation: "one-to-many",
      label: "Contatto",
      icon: "UserOutlined",
      displayField: "lastname",
    },
  ],
  requiredFields: ["title"],
  viewStrategy: "generic",
};
